import {createAsyncThunk} from "@reduxjs/toolkit";
import instance from "../AxiosOrders";


export const getEmployeeList = createAsyncThunk('employee/getAll', async (employee, {rejectWithValue}) => {
    try {
        const {data} = await instance.get(`/employee?page=${employee?.page}`);
        return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const saveEmployee = createAsyncThunk('employee/save', async (page, { rejectWithValue }) => {
    try {
        const { data } = await instance.post(`/employee`, page, {
            headers: {"Content-type": "application/json"},
        });
        return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
})

export const updateEmployee = createAsyncThunk('employee/update', async ({id, page}, { rejectWithValue }) => {
    try {
        const { data } = await instance.put(`/employee/${id}`, page, {
            headers: {"Content-type": "application/json"},
        });
        return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
})

export const deleteEmployee = createAsyncThunk('employee/delete', async (id, { rejectWithValue }) => {
    try {
        const data = await instance.delete(`/employee/${id}`);
        return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
}
);